import { FIND_MODULES_REQUEST, findModulesSuccess, findModulesFailure} from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

export function findModulesEpic(action$, store$, { ModuleRepository }) {
    return action$.pipe(
        ofType( FIND_MODULES_REQUEST ),
        mergeMap(action => from(
            ModuleRepository.findAll(action.payload)
                .then(({ modules, meta }) => findModulesSuccess({ modules, response: meta, request: action}))
                .catch(error => findModulesFailure({ error, request: action })),
        )),
    );
}
